import { areaBranchTeamService } from "../../Service/AreaBranchTeam.service";
let initialState = {
  selectedArea: {},
  selectedTeam: {},
  selectedBranch: {},
  allAreaTeamBranch: [],
  filterPeriod: "",
  financialYear: null,
  currentFilter: {
    FinancialYear: null,
    CurrentYear: null,
    Month: "",
    MonthName: "",
  },
  selectedGroupBy: "",
  GroupByList: ["Area", "Team"],
};

const state = { ...initialState };

const getters = {
  getSelectedArea(state) {
    return state.selectedArea;
  },
  getSelectedTeam(state) {
    return state.selectedTeam;
  },
  getSelectedBranch(state) {
    return state.selectedBranch;
  },
  getAllAreaTeamBranch(state) {
    return state.allAreaTeamBranch;
  },
  getFilterPeriod() {
    return state.currentFilter.MonthName;
  },
  getFinancialYear() {
    return state.currentFilter.FinancialYear;
  },
  getCurrentFilters() {
    return state.currentFilter;
  },
  getSelectedGroupBy() {
    return state.selectedGroupBy;
  },
  getGroupByList() {
    return state.GroupByList;
  },
};

const mutations = {
  setSelectedArea(state, selectedArea) {
    state.selectedArea = selectedArea;
  },
  setSelectedTeam(state, selectedTeam) {
    state.selectedTeam = selectedTeam;
  },
  setSelectedBranch(state, selectedBranch) {
    state.selectedBranch = selectedBranch;
  },
  setAllAreaTeamBranch(state, areaTeamBranch) {
    state.allAreaTeamBranch = areaTeamBranch;
  },
  setFilterPeriod(state, filterPeriod) {
    state.filterPeriod = filterPeriod;
  },
  setFinancialYear(state, year) {
    state.financialYear = year;
  },
  setFilter(state, filter) {
    state.currentFilter = filter;
  },
  resetFilterStore(state) {
    state.selectedArea = {};
    state.selectedTeam = {};
    state.selectedBranch = {};
    state.allAreaTeamBranch = [];
  },
  setSelectedGroupBy(state, groupBy) {
    state.selectedGroupBy = groupBy;
  },
};

const actions = {
  changeArea(context, selectedArea) {
    context.commit("setSelectedArea", selectedArea);
  },
  changeTeam(context, selectedTeam) {
    context.commit("setSelectedTeam", selectedTeam);
  },
  changeBranch(context, selectedBranch) {
    context.commit("setSelectedBranch", selectedBranch);
  },
  async getAreaBranchTeamService(context) {
    if (context.state.allAreaTeamBranch.length == 0) {
      var result = await areaBranchTeamService();

      if (result != null && result.length != 0) {
        context.commit("setAllAreaTeamBranch", result);
      } else {
        context.commit("setAllAreaTeamBranch", []);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
